// extracted by mini-css-extract-plugin
export default {"statusPanel":"Fr1m-8lGCQLZ4ir4NgDDh","chooseButtonWrapper":"_2EWephcHuoLE4spsgltS63","checkListForClaimBack":"fR3wmeEZrUB96rUrhcb3T"};